export function initProjectBoardList() {
    document.addEventListener('DOMContentLoaded', async function () {
        const container = document.getElementById('project-board-list-container');
        
        if (container) {
            const defaultBoardImage = container?.dataset.defaultBoardImage;
            const listModule = await import('./projectboardlist.jsx');
            listModule.initProjectBoardList(container, defaultBoardImage);
        }
    });
}